import styled from 'styled-components';
import React from 'react';
import { Divider, Headline, Icon, Text, } from '@oneaudi/unified-web-components';
import { SYS_BREAKPOINT_LG, SYS_BREAKPOINT_MD, SYS_BREAKPOINT_XL, SYS_COLOR_SURFACE_NEUTRAL_700_DARK, SYS_SPACE_FIXED_200, SYS_SPACE_FIXED_300, SYS_SPACE_FIXED_350, SYS_SPACE_FIXED_450, SYS_SPACE_RELATIVE_2_XL, SYS_SPACE_RELATIVE_3_XL, SYS_SPACE_RELATIVE_6_XL, SYS_SPACE_RELATIVE_7_XL, } from '@oneaudi/unified-web-common';
import { dynamicStylingHelper, GetSafeColorDesignToken } from '../../utils/AlphaHelper';
import { SYS_COLOR_CANVAS_200_DARK, SEM_COLOR_ACTION_PRIMARY_FOREGROUND_ICON_DEFAULT_DARK, SYS_SPACE_FIXED_400, SYS_SPACE_RELATIVE_XL, SYS_SPACE_FIXED_500, SEM_COLOR_FORMS_FOREGROUND_DIVIDER_DEFAULT_DARK, } from '@oneaudi/unified-web-alpha-common';
export const transitionAccordionDuration = 400;
export const FilterOverlayContainer = styled.div `
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100vw;
  z-index: 5006;
  overflow-y: scroll;
  overflow-x: hidden;
  scroll-behavior: smooth;
  opacity: 1;
  background-color: ${GetSafeColorDesignToken('FILTER_OVERLAY')};

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    height: 100vh;
  }
`;
export const WidthSpacer = styled.div `
  display: none;

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    display: block;
    width: 50%;
  }
`;
export const Container = styled.div `
  margin-bottom: 89px;
`;
export const FilterHeadline = styled.div `
  display: flex;
  margin: ${dynamicStylingHelper(`${SYS_SPACE_FIXED_300} 0`, `23px ${SYS_SPACE_FIXED_400} 24px ${SYS_SPACE_FIXED_400}`)};
`;
export const OuterChipsContainer = styled.div `
  padding-bottom: ${SYS_SPACE_RELATIVE_7_XL};

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    display: flex;
    justify-content: center;
  }
`;
export const ChipsContent = styled.div `
  margin-top: ${SYS_SPACE_FIXED_200};
  margin-left: ${SYS_SPACE_FIXED_200};
  margin-right: ${SYS_SPACE_FIXED_200};

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    margin-top: 0;
    margin-bottom: 90px;
    margin: 0 40px;
    width: 100%;
  }

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    margin: 0 60px 90px 60px;
  }
  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    margin: 0 96px 90px 96px;
    max-width: 1920px;
  }
`;
export const StyledDivider = styled((props) => (React.createElement(Divider, Object.assign({ spaceStackEnd: "xl" }, props)))) `
  display: none;

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    display: block;
  }
`;
export const StyledTextChosenFilters = styled((props) => (React.createElement(Headline, Object.assign({ tag: "h3", variant: { order: '4', type: 'headline', weight: 'normal' } }, props)))) `
  margin-top: ${dynamicStylingHelper(SYS_SPACE_FIXED_450, SYS_SPACE_RELATIVE_XL)};
  margin-bottom: ${dynamicStylingHelper(SYS_SPACE_FIXED_450, SYS_SPACE_RELATIVE_XL)};
`;
export const FilterOverlayNavigationMobile = styled.div `
  display: block;
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    display: none;
  }
`;
export const FilterOverlayNavigationHeaderMobile = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: ${GetSafeColorDesignToken('FILTER_OVERLAY_HEADER')};
  backdrop-filter: blur(${GetSafeColorDesignToken('FILTER_OVERLAY_BLUR')});
  border-width: 1px 0;
  width: 100%;
  z-index: 4;

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    display: none;
  }
`;
export const AccordionContainer = styled.div `
  margin-top: 72px;
  pointer-events: none;

  &.active {
    pointer-events: all;
  }
`;
export const FilterOverlayNavigationDesktopContainer = styled.div `
  display: none;
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    display: block;
    position: sticky;
    background-color: ${GetSafeColorDesignToken('FILTER_OVERLAY_NAVIGATION')};
    backdrop-filter: blur(${GetSafeColorDesignToken('FILTER_OVERLAY_BLUR')});
    top: 0;
    z-index: 3;
  }
`;
export const FilterOverlayNavigationDesktop = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1920px;

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    margin: 0 40px;
  }
  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    margin: 0 60px;
  }
  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    margin: 0 auto;
    padding: 0 96px;
  }
`;
export const FilterOverlayBodyContainer = styled.div `
  display: none;

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    display: block;
    background-color: ${GetSafeColorDesignToken('FILTER_OVERLAY')};
    height: auto;
    padding-bottom: ${(props) => (props.openedChipsContainer ? '0' : '90px')};
  }
`;
export const FilterOverlayContent = styled.div `
  max-width: 1920px;

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    margin: 0 40px;
    margin-top: ${dynamicStylingHelper('0', SYS_SPACE_RELATIVE_2_XL)};
  }
  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    margin: 0 60px;
    margin-top: ${dynamicStylingHelper('0', SYS_SPACE_RELATIVE_2_XL)};
  }
  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    margin: 0 auto;
    padding: 0 96px;
    margin-top: ${dynamicStylingHelper('0', SYS_SPACE_RELATIVE_2_XL)};
  }
`;
export const ContentSection = styled.div `
  padding-top: ${dynamicStylingHelper(SYS_SPACE_RELATIVE_6_XL, '0')};
`;
export const HeadingWrapper = styled.div ``;
export const StyledHeadline = styled((props) => React.createElement(Headline, Object.assign({}, props))) `
  display: flex;
  flex-direction: column;
  color: ${GetSafeColorDesignToken('HEADLINE_ORDER1_LIGHT')};
  gap: ${dynamicStylingHelper(SYS_SPACE_FIXED_350, SYS_SPACE_RELATIVE_XL)};
`;
export const RenderedFiltersWrapper = styled.div `
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;
export const FilterOverlayNavigationDesktopWrapper = styled.div `
  display: flex;
  align-items: center;
  overflow-x: auto;
`;
export const FilterOverlayNavigationCategoriesDesktop = styled.div `
  overflow-x: auto;
`;
export const FilterOverlayFooterContainer = styled.div `
  position: fixed;
  bottom: 0;
  right: 0;
  background-color: ${GetSafeColorDesignToken('FILTER_OVERLAY_FOOTER')};
  backdrop-filter: blur(${GetSafeColorDesignToken('FILTER_OVERLAY_BLUR')});
  border-width: 1px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  z-index: 3;
  left: 0;
`;
export const StyledText = styled((props) => (React.createElement(Text, Object.assign({ tag: "span", variant: {
        order: '1',
        style: 'normal',
        type: 'copy',
    } }, props)))) `
  display: none;

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    text-wrap: nowrap;
    display: block;
  }
`;
export const StyledResultsButtonWrapper = styled.div `
  margin-right: 24px;
  margin-left: 24px;
  width: 100%;
  text-align: center;

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    width: 50%;
    display: flex;
    justify-content: end;
    margin-left: 0;
    margin-right: ${SYS_SPACE_FIXED_300};
  }
`;
export const StyledDeleteFiltersButtonWrapper = styled.div `
  display: none;

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    display: flex;
    width: 50%;
  }
`;
export const FilterOverlayAccordionContainer = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: stretch;
`;
export const FilterAccordionSectionContent = styled.div `
  --button-position: static;
  all: revert;
  margin: 0;
  z-index: ${(props) => (props.isUsedInLocationFilter ? '0' : '3')};
  position: var(--button-position);
  top: 72px;

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    z-index: ${(props) => props.isUsedInEquipmentFilter || props.isUsedInLocationFilter ? '0' : '2'};
  }

  &:not(:first-child) {
    margin-top: 0px;
  }

  &:focus-within {
    z-index: 1;
  }
`;
export const AccordionSectionHeaderButton = styled.button `
  all: revert;
  display: block;
  width: 100%;
  margin: 0;
  padding: 0;
  text-align: start;
  background: transparent;
  border-top-style: solid;
  border-top-color: ${dynamicStylingHelper('hsla(0, 0%, 85%, 1)', SEM_COLOR_FORMS_FOREGROUND_DIVIDER_DEFAULT_DARK)};
  border-top-width: ${dynamicStylingHelper('1px', '2px')};
  cursor: pointer;
  appearance: none;
  background-color: ${GetSafeColorDesignToken('FILTER_OVERLAY')};
  border-bottom-width: ${(props) => props.isLast && !props.open && dynamicStylingHelper('1px', '2px')};
  border-bottom-style: ${(props) => (props.isLast && !props.open ? 'solid' : 'unset')};
  border-bottom-color: ${(props) => props.isLast && !props.open && props.isLegacy
    ? 'hsla(0, 0%, 85%, 1)'
    : props.isLast && !props.open && !props.isLegacy
        ? SEM_COLOR_FORMS_FOREGROUND_DIVIDER_DEFAULT_DARK
        : dynamicStylingHelper('transparent', 'none')};
  border-left: unset;
  border-right: unset;
`;
export const AccordionSectionHeaderButtonContent = styled.span `
  display: grid;
  grid-template-columns:
    [section-icon] minmax(0, max-content)
    [section-label] auto
    [arrow-icon] max-content;
  padding: ${SYS_SPACE_FIXED_200};
`;
export const StyledIcon = styled((props) => (React.createElement(Icon, Object.assign({ name: "arrow-down", size: "s" }, props)))) `
  grid-column: arrow-icon;
  grid-row: 1 / span 3;
  align-self: center;
  width: 24px;
  height: 24px;
  color: ${dynamicStylingHelper('#333333', `${SEM_COLOR_ACTION_PRIMARY_FOREGROUND_ICON_DEFAULT_DARK}`)};
  transform: rotateZ(${(props) => (props.open ? -180 : 0)}deg);
  transition: transform 200ms var(${(props) => props.theme.easing});
  pointer-events: none;
  [dir='rtl'] & {
    transform: rotateZ(${(props) => (props.open ? 180 : 0)}deg);
  }
`;
export const AccordionSectionPanel = styled.div `
  --panel-height: ${(props) => (props.defaultOpen ? 'auto' : '0px')};
  box-sizing: border-box;
  height: var(--panel-height);
  overflow: hidden;
  background-color: ${(props) => props.isUsedInLocationFilter && (props.open || props.isDisplayingFocusedDealer)
    ? GetSafeColorDesignToken('DEALER_ACCORDION_OPEN')
    : props.isUsedInLocationFilter
        ? dynamicStylingHelper('#f2f2f2', SYS_COLOR_CANVAS_200_DARK)
        : props.isUsedInEquipmentFilter
            ? GetSafeColorDesignToken('EQUIPMENT_ACCORDION_SECTION')
            : (props === null || props === void 0 ? void 0 : props.isDisplayingFocusedDealer)
                ? GetSafeColorDesignToken('dark')
                : GetSafeColorDesignToken('MOBILE_NAVIGATION')};
  visibility: ${(props) => (props.open ? 'visible' : 'hidden')};
  transition: ${transitionAccordionDuration}ms var(${(props) => props.theme.easing});
  transition-property: height, visibility;

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    background-color: ${(props) => props.isUsedInLocationFilter && (props.open || props.isDisplayingFocusedDealer)
    ? GetSafeColorDesignToken('DEALER_ACCORDION_OPEN')
    : props.isUsedInLocationFilter
        ? dynamicStylingHelper(SYS_COLOR_SURFACE_NEUTRAL_700_DARK, 'unset')
        : !props.isUsedInEquipmentFilter && props.open
            ? GetSafeColorDesignToken('inverted')
            : props.isUsedInEquipmentFilter
                ? GetSafeColorDesignToken('EQUIPMENT_ACCORDION_SECTION')
                : (props === null || props === void 0 ? void 0 : props.isDisplayingFocusedDealer)
                    ? GetSafeColorDesignToken('FOCUSED_DEALER')
                    : GetSafeColorDesignToken('inverted')};
  }

  margin-bottom: ${(props) => props.isUsedInEquipmentFilter &&
    props.isLast &&
    !props.open &&
    dynamicStylingHelper('0', SYS_SPACE_RELATIVE_3_XL)};
`;
export const AccordionSectionPanelContent = styled.div `
  --inset: ${SYS_SPACE_FIXED_200};
  --locationfilterpadding: calc(
    var(--spacing-relative-lg) + var(--spacing-relative-sm) + var(--spacing-relative-sm)
  );

  box-sizing: border-box;
  padding-block-start: ${(props) => (props.isUsedInLocationFilter ? '0' : 'var(--inset)')};
  padding-inline-end: var(
    ${(props) => (props.isUsedInLocationFilter ? '--spacing-relative-sm' : '--inset')}
  );
  padding-block-end: var(
    ${(props) => (props.isUsedInLocationFilter ? '--spacing-relative-lg' : '--inset')}
  );
  padding-inline-start: var(
    ${(props) => (props.isUsedInLocationFilter ? '--locationfilterpadding' : '--inset')}
  );
  transform: ${(props) => !props.open && 'translateY(calc(var(--inset) / 2))'};
  opacity: ${(props) => (props.open ? 1 : 0)};
  transition-delay: ${(props) => (props.open ? transitionAccordionDuration * 0.2 : 0)}ms;
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: ${transitionAccordionDuration * 0.8}ms;
  transition-property: transform, opacity;

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    padding: ${(props) => !props.isUsedInLocationFilter && dynamicStylingHelper('var(--inset)', SYS_SPACE_FIXED_500)};
    padding-bottom: ${(props) => !props.isUsedInLocationFilter && dynamicStylingHelper('var(--inset)', SYS_SPACE_FIXED_200)};
  }
`;
export const DealerAccordionItemHeaderWrapper = styled.div `
  display: grid;
  grid-template-columns: 1fr 56px;
  // eslint-disable-next-line no-nested-ternary
  background-color: ${(props) => props.isDisplayingFocusedDealerBellowMap
    ? GetSafeColorDesignToken('DEALER_ACCORDION')
    : props.open
        ? GetSafeColorDesignToken('DEALER_ACCORDION_OPEN')
        : 'unset'};
  border-block-start: ${dynamicStylingHelper('1px solid hsla(0, 0%, 85%, 1)', `2px solid ${SEM_COLOR_FORMS_FOREGROUND_DIVIDER_DEFAULT_DARK}`)};

  /* prevent vertical stretching when the dealer name line breaks */
  button {
    align-self: start;
  }
`;
